/**
 * Нормализация названий платформ.
 *
 * Живёт в схеме, а не в коллекторе, потому что нужна обеим сторонам: коллектор
 * заполняет ими сигналы, движок правил по ним сверяет слои. Функции чистые и
 * не трогают браузерные API.
 */

export type PlatformFamily = 'windows' | 'macos' | 'linux' | 'android' | 'ios' | 'bsd' | 'other';

/** Приводит `navigator.platform` к семейству платформы. */
export function platformFamilyOf(platform: string | null): PlatformFamily | null {
  if (!platform) return null;
  const p = platform.toLowerCase();
  if (p.startsWith('win')) return 'windows';
  if (p.includes('iphone') || p.includes('ipad') || p.includes('ipod')) return 'ios';
  if (p.startsWith('mac')) return 'macos';
  if (p.includes('android')) return 'android';
  if (p.includes('cros')) return 'linux';
  if (p.includes('linux') || p.includes('x11')) return 'linux';
  if (p.includes('bsd')) return 'bsd';
  return null;
}

/** То же для `navigator.userAgentData.platform` («Windows», «macOS», «Linux»…). */
export function uaDataPlatformFamily(platform: string | null): PlatformFamily | null {
  if (!platform) return null;
  switch (platform.toLowerCase()) {
    case 'windows':
      return 'windows';
    case 'macos':
    case 'mac os x':
      return 'macos';
    case 'linux':
      return 'linux';
    case 'android':
      return 'android';
    case 'ios':
      return 'ios';
    case 'chrome os':
    case 'chromeos':
      return 'linux';
    default:
      return null;
  }
}

export const PLATFORM_LABELS: Record<string, string> = {
  windows: 'Windows',
  macos: 'macOS',
  linux: 'Linux',
  android: 'Android',
  ios: 'iOS',
  bsd: 'BSD',
  other: 'неизвестная система',
};
